import { Component, Input } from '@angular/core';
import { BOProduct } from '@boels/models';
import { Observable } from 'rxjs';
import { BimModelListItemComponent } from '../bim-model-list-item/bim-model-list-item.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'boels-bim-model-list',
  templateUrl: './bim-model-list.component.html',
  styleUrls: ['./bim-model-list.component.scss'],
  imports: [BimModelListItemComponent, AsyncPipe],
})
export class BimModelListComponent {
  @Input()
  product$: Observable<BOProduct>;
}
